var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import CLIcon from '../../../../../ui/atoms/Icon';
import query from 'syf-component-library/const/mediaQueries';
export var Icon = styled(CLIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    return color || theme.icon;
});
export var IconText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-grow: 2;\n  @media ", " {\n    align-items: start;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  flex-grow: 2;\n  @media ", " {\n    align-items: start;\n  }\n"])), query.lessThanMedium);
var templateObject_1, templateObject_2;
//# sourceMappingURL=subcomponents.js.map